import { useSelector } from 'react-redux';
import { RootState } from '../redux/rootReducer';
import { FolderDb } from '../redux/folderDbSlice';

const useOneFolderDb = (id: string | undefined) : FolderDb| undefined => {
  const folderDb = useSelector((state: RootState) => state.folderDb);
  const folderValue = id ? folderDb.folders[id] : undefined;
  return folderValue;
}

export default useOneFolderDb